import React from 'react';
import PropTypes from 'prop-types';
import { PageNotFound, CatalogRestricted, UnauthorizedAccess } from 'pages';
import { allowedServices, isDiscontinuedService } from 'utils';
import { getDiscontinuedDescription } from 'utils/discontinuedCatalogs';
import { canAccessCatalog, isAnnouncementRestricted, getAnnouncementRestrictionMessage } from 'utils/announcementRestrictions';

function CatalogRouteGuard({ component: Component, render: renderFn, ...props }) {
    const { catalogCode } = props.match.params;
    if (catalogCode && !canAccessCatalog(catalogCode)) {
        // 1. Disabled via active announcement → show the announcement reason
        if (isAnnouncementRestricted(catalogCode)) {
            return (
                <CatalogRestricted
                    title="Catalog Unavailable"
                    description="The feature catalog you are attempting to access has been disabled due to an announcement:"
                    message={getAnnouncementRestrictionMessage(catalogCode)}
                />
            );
        }
        // 2. Discontinued/retired → reuse the existing recommendation message
        if (isDiscontinuedService(catalogCode)) {
            return <CatalogRestricted title="Catalog Discontinued" message={getDiscontinuedDescription(catalogCode)} />;
        }
        // 3. Scoped catalog without admin/beta access → unauthorized, not "not found"
        if (!allowedServices(catalogCode)) {
            return <UnauthorizedAccess />;
        }
        return <PageNotFound />;
    }
    if (renderFn) {
        return renderFn(props);
    }
    return <Component {...props} />;
}

CatalogRouteGuard.propTypes = {
    component: PropTypes.elementType,
    render: PropTypes.func,
    match: PropTypes.shape({
        params: PropTypes.shape({
            catalogCode: PropTypes.string,
        }),
    }).isRequired,
};

CatalogRouteGuard.defaultProps = {
    component: undefined,
    render: undefined,
};

export default CatalogRouteGuard;
